'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _semanticUiReact = require('semantic-ui-react');

var _formatting = require('./../../../utils/formatting');

var _notAvailableComponent = require('../../not-available-component');

var _notAvailableComponent2 = _interopRequireDefault(_notAvailableComponent);

var _imageComponent = require('./../components/image-component');

var _imageComponent2 = _interopRequireDefault(_imageComponent);

var _mobile = require('./../mobile');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAssetType = function getAssetType(post) {
  if (_lodash2.default.get(post, 'isVideo')) {
    return 'VIDEO';
  }
  return _lodash2.default.get(post, 'trackedAsset.assetType', 'IMAGE');
};

var InstagramPostMobile = function InstagramPostMobile(_ref) {
  var post = _ref.post;
  return _react2.default.createElement(
    _semanticUiReact.Card.Content,
    { style: _mobile.styles.dividerStyle },
    _react2.default.createElement(
      _semanticUiReact.Grid,
      null,
      _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 6 },
          _react2.default.createElement(_imageComponent2.default, { post: post, inMobileMode: true })
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 10, textAlign: 'center' },
          _react2.default.createElement(
            _semanticUiReact.Label,
            { fluid: true },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram', color: 'pink' }),
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle', color: 'pink' }),
            _react2.default.createElement(
              'small',
              null,
              _lodash2.default.toUpper(getAssetType(post)),
              ' @ ',
              _lodash2.default.get(post, 'instagramHandle')
            )
          ),
          _react2.default.createElement(_semanticUiReact.Divider, null),
          _react2.default.createElement(
            'p',
            { style: _mobile.styles.caption },
            _lodash2.default.truncate(_lodash2.default.get(post, 'text'), { length: 50 })
          ),
          _react2.default.createElement(_semanticUiReact.Divider, null),
          _react2.default.createElement(
            _semanticUiReact.Statistic.Group,
            { size: 'mini', widths: 'three' },
            _react2.default.createElement(
              _semanticUiReact.Statistic,
              null,
              _react2.default.createElement(
                _semanticUiReact.Statistic.Value,
                null,
                (0, _formatting.sciFormatted)(_lodash2.default.get(post, 'latestInsights.impressions'))
              ),
              _react2.default.createElement(
                _semanticUiReact.Statistic.Label,
                null,
                'imps'
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Statistic,
              null,
              _react2.default.createElement(
                _semanticUiReact.Statistic.Value,
                null,
                (0, _formatting.sciFormatted)(_lodash2.default.get(post, 'latestInsights.reach'))
              ),
              _react2.default.createElement(
                _semanticUiReact.Statistic.Label,
                null,
                'reach'
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Statistic,
              null,
              _react2.default.createElement(
                _semanticUiReact.Statistic.Value,
                null,
                _react2.default.createElement(_notAvailableComponent2.default, null)
              ),
              _react2.default.createElement(
                _semanticUiReact.Statistic.Label,
                null,
                'engs'
              )
            )
          )
        )
      )
    )
  );
};

InstagramPostMobile.propTypes = {
  post: _propTypes2.default.object.isRequired
};

exports.default = InstagramPostMobile;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dyzio-shared-components/lib/reports/paid-report-row/mobile-components/instagram-post.js
// module id = 2139
// module chunks = 1